var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.3 51.1",
    style: {
      enableBackground: "new 0 0 36.3 51.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E44D26;}\r\n\t.st1{fill:#F16529;}\r\n\t.st2{fill:#EBEBEB;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#264DE4;}\r\n\t.st5{fill:#2965F1;}\r\n\t.st6{fill:#DAB92D;}\r\n\t.st7{fill:#FFD839;}\r\n\t.st8{fill:#53C1DE;}\r\n\t.st9{fill:#002A41;}\r\n\t.st10{fill:#0071B5;}\r\n\t.st11{fill:#DF4F4F;}\r\n\t.st12{fill:#26262C;}\r\n\t.st13{fill:#CCCCCC;}\r\n\t.st14{fill:#A6120D;}\r\n\t.st15{fill:#B3B3B3;}\r\n\t.st16{fill:#DD1B16;}\r\n\t.st17{fill:#F2F2F2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18,51.2L3.2,47.1L-0.1,10h36.3l-3.3,37L18,51.2L18,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30,44.7L32.8,13H18.1v35L30,44.7L30,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.4,26.8l0.4,4.6H18v-4.6C18,26.8,7.4,26.8,7.4,26.8z M6.6,17.6L7,22.2h11v-4.6H6.6L6.6,17.6z M18,38.7 L18,38.7l-5.1-1.4l-0.3-3.6H8l0.7,7.1l9.3,2.6l0,0C18,43.4,18,38.7,18,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,0h5.5v2.3h-3.2v2.3h3.2v2.3H8.4V0z M15,0h5.5v2h-3.2v0.4h3.2V7H15V4.9h3.2V4.5H15V0L15,0z M21.6,0h5.5v2h-3.2v0.4h3.2 V7h-5.5V4.9h3.2V4.5h-3.2V0L21.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.6,26.8l0.8-9.2H18v4.6h6.4L24,26.8h-6v4.6h5.6l-0.5,5.9L18,38.7v4.8l9.3-2.6l0.1-0.8l1.1-12L28.6,26.8 L28.6,26.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.0709eb33a1b802d9f46070af2625a4b6.svg";
export { ForwardRef as ReactComponent };